import React from "react";

interface SettingsFieldProps {
	label: string;
	htmlFor: string;
	children: React.ReactNode;
	/** Field-level message, shown under the input. */
	error?: string | null;
}

/** Label + control + error, so the two forms lay out identically. */
const SettingsField: React.FC<SettingsFieldProps> = ({
	label,
	htmlFor,
	children,
	error,
}) => (
	<div>
		<label
			htmlFor={htmlFor}
			className="block text-sm font-normal text-text-muted mb-1"
		>
			{label}
		</label>
		{children}
		{error && <p className="mt-1 text-xs text-red-600">{error}</p>}
	</div>
);

export default SettingsField;
